
import React from 'react';
import GenerateRedFlagImage from './GenerateRedFlagImage';
import CustomRedFlagImage from './CustomRedFlagImage';
import PageLayout from '@/components/PageLayout';

const FlagImageGenerator = () => {
  return (
    <PageLayout 
      title="Red Flag Images" 
      description="Download your RedFlags logo as a 300x300 JPG image"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <GenerateRedFlagImage />
        <CustomRedFlagImage />
      </div>
      <div className="text-center mt-8">
        <p className="text-redflags-gray">
          Click on the download button below each image to save the JPG version.
        </p>
      </div>
    </PageLayout>
  );
};

export default FlagImageGenerator;
